<template>
    <div v-if="props.advisoryText" class="program-label__text">{{ props.advisoryText }}</div>
    <div v-if="props.highDefinition" class="program-label__text">HD</div>
    <div v-if="props.closedCaptions" class="program-label__text">CC</div>
    <common-icon v-if="props.descriptiveAudio" class="program-label__icon" :icon-name="'IconDescribedVideo'" />
    <common-icon v-if="props.isRestartAvailable" class="program-label__icon" :icon-name="'IconRestart'" />
</template>

<script setup lang="ts">
    import type { IProgramInfo } from "@/composables/useProgramInfo/types";
    
    const props = defineProps<{
        advisoryText: IProgramInfo['advisoryText'];
        highDefinition: IProgramInfo['highDefinition'];
        closedCaptions: IProgramInfo['closedCaptions'];
        descriptiveAudio: IProgramInfo['descriptiveAudio'];
        isRestartAvailable: IProgramInfo['isRestartAvailable'];
    }>();
</script>

<style lang="scss">
    @import url("styles.scss");
</style>
